import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group-hover:opacity-100 transition-opacity bg-mono-ns-200 px-6 py-1 text-p6 rounded-lg absolute left-1/2 -translate-x-1/2 -translate-y-10 opacity-0 mx-auto whitespace-nowrap" }




export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipComponent',
  props: {
    label: {}
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(props.label) + " ", 1),
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "absolute -bottom-1 left-1/2 -z-10 h-3 w-3 -translate-x-1/2 rotate-45 bg-mono-ns-200" }, null, -1))
  ]))
}
}

})